import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Andheritopunecab() {



  const cardData = {


  keyword: "Andheri to Pune Cabs",

  headingDescription: "Trustline Cab provides reliable Andheri to Pune cab services with safe, comfortable, and affordable transportation for business travel, airport transfers, corporate meetings, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure punctual pickups, smooth highway travel, and a hassle-free journey from Andheri to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible travel schedules, experienced drivers, and 24/7 customer support, Trustline Travels is your trusted choice for Andheri to Pune taxi services.",

  topPlaces: [
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's largest technology and corporate hub, featuring multinational companies, software firms, startups, and business campuses. It is a major destination for IT professionals and corporate travelers arriving from Mumbai."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport is an important aviation hub connecting Pune with major Indian cities. It is frequently used by business travelers, tourists, and corporate passengers who require comfortable airport transfer services."
    },
    {
      title: "EON IT Park Kharadi",
      description: "EON IT Park in Kharadi is one of Pune's leading business and technology destinations, housing global companies, IT firms, financial organizations, and modern corporate offices. It attracts professionals throughout the year."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is a major industrial and commercial region known for automobile companies, manufacturing units, engineering firms, and business establishments. It is a preferred destination for corporate and industrial travel."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a well-planned business township offering IT parks, corporate offices, residential communities, shopping areas, and modern facilities. It is a popular destination for professionals and families visiting Pune."
    },
    {
      title: "Viman Nagar",
      description: "Viman Nagar is a premium Pune locality near the airport, known for IT companies, shopping malls, hotels, restaurants, and commercial spaces. It is a preferred location for business travelers and visitors."
    },
    {
      title: "Koregaon Park",
      description: "Koregaon Park is one of Pune's most popular lifestyle destinations, known for luxury hotels, cafés, restaurants, shopping areas, and entertainment options. It attracts tourists, corporate visitors, and professionals."
    },
    {
      title: "Shivajinagar",
      description: "Shivajinagar is a central Pune area featuring commercial offices, educational institutions, government establishments, markets, and excellent connectivity. It is an important destination for business and daily travel."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station located between Mumbai and Pune, famous for waterfalls, green valleys, viewpoints, caves, and pleasant weather. It is a popular getaway and sightseeing destination on the route."
    },
    {
      title: "Sinhagad Fort",
      description: "Sinhagad Fort is a historic hill fort near Pune offering scenic views, trekking experiences, and cultural importance. It is a popular weekend destination for adventure lovers and travelers exploring Pune."
    }
  ],






"services": [
  {
    "name": "Andheri to Pune Taxi",
    "description": "Book Andheri to Pune Taxi for safe and comfortable intercity travel with professional chauffeurs, clean AC vehicles, transparent pricing, and reliable service. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cars for business trips, family travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Andheri to Pune Round Trip Cab",
    "description": "Choose Andheri to Pune Round Trip Cab for flexible return travel with experienced drivers, comfortable seating, spacious luggage capacity, affordable fares, and convenient pickup and drop service."
  },
  {
    "name": "Andheri to Pune Innova Crysta",
    "description": "Book Andheri to Pune Innova Crysta for premium family and corporate travel with luxury interiors, spacious seating, AC comfort, professional chauffeurs, and smooth highway journeys."
  },
  {
    "name": "Taxi from Mumbai Andheri to Pune",
    "description": "Reserve Taxi from Mumbai Andheri to Pune for direct intercity travel with fixed pricing, clean vehicles, experienced drivers, doorstep pickup, and comfortable transportation."
  },
  {
    "name": "Andheri to Pune Ertiga Taxi Fare",
    "description": "Check Andheri to Pune Ertiga Taxi Fare with affordable pricing, transparent charges, spacious seating, and reliable chauffeur-driven Ertiga cab service."
  },
  {
    "name": "Andheri to Hinjewadi Cab Fare",
    "description": "Get Andheri to Hinjewadi Cab Fare with comfortable vehicles, professional drivers, affordable rates, and dependable transportation for IT professionals and business travelers."
  },
  {
    "name": "Andheri Airport to Pune Taxi Fare",
    "description": "Find Andheri Airport to Pune Taxi Fare with competitive pricing, airport pickup facilities, premium vehicles, luggage support, and reliable travel service."
  },
  {
    "name": "Mumbai Airport to Baner Cab Fare",
    "description": "Book Mumbai Airport to Baner Cab Fare service with comfortable AC cars, professional chauffeurs, transparent pricing, and smooth airport transfer solutions."
  },
  {
    "name": "One Way Round Trip Cab from Mumbai",
    "description": "Choose One Way Round Trip Cab from Mumbai for flexible travel options with affordable fares, multiple vehicle choices, and professional driver support."
  },
  {
    "name": "Juhu to Pune Cab Service",
    "description": "Book Juhu to Pune Cab Service for comfortable intercity travel with clean AC vehicles, experienced chauffeurs, doorstep pickup, and reliable transportation."
  },
  {
    "name": "Cab Service in Juhu Mumbai",
    "description": "Choose Cab Service in Juhu Mumbai for local and outstation travel with premium vehicles, affordable fares, professional drivers, and quick booking support."
  },
  {
    "name": "Juhu to Pune One Way Cab Fare",
    "description": "Check Juhu to Pune One Way Cab Fare with transparent pricing, comfortable cars, fixed rates, and reliable one-side travel service."
  },
  {
    "name": "Sakinaka to Pune Cab Service",
    "description": "Book Sakinaka to Pune Cab Service for safe and affordable travel with experienced drivers, clean vehicles, and flexible pickup options."
  },
  {
    "name": "Marol to Pune Cab",
    "description": "Choose Marol to Pune Cab for comfortable highway travel with premium AC vehicles, professional chauffeurs, and affordable pricing."
  },
  {
    "name": "Andheri to Pune Cab",
    "description": "Book Andheri to Pune Cab for one-way, round-trip, airport, and outstation travel with multiple vehicle options and reliable chauffeur service."
  },
  {
    "name": "Pune to Andheri Cab",
    "description": "Reserve Pune to Andheri Cab for convenient return travel with experienced drivers, comfortable vehicles, and transparent fares."
  },
  {
    "name": "Andheri to Pune Cab Innova Crysta",
    "description": "Choose Andheri to Pune Cab Innova Crysta for luxury travel with premium comfort, spacious interiors, and professional driver assistance."
  },
  {
    "name": "Andheri to Pune Station Cab",
    "description": "Book Andheri to Pune Station Cab for railway transfers with punctual pickup, clean cars, and reliable transportation."
  },
  {
    "name": "Cab Service in Andheri",
    "description": "Get Cab Service in Andheri for local and outstation travel with affordable rates, professional chauffeurs, and premium vehicle options."
  },
  {
    "name": "Taxi Service in Andheri East",
    "description": "Choose Taxi Service in Andheri East for comfortable rides, airport transfers, business travel, and reliable cab solutions."
  },
  {
    "name": "Taxi Service in Andheri West",
    "description": "Book Taxi Service in Andheri West with experienced drivers, AC vehicles, affordable pricing, and convenient travel support."
  },
  {
    "name": "Andheri to Pune Cab Service",
    "description": "Reserve Andheri to Pune Cab Service for safe intercity journeys with premium cars, transparent fares, and professional chauffeurs."
  },
  {
    "name": "Andheri to Pune Taxi Service",
    "description": "Choose Andheri to Pune Taxi Service for reliable transportation with clean vehicles, experienced drivers, and flexible booking options."
  },
  {
    "name": "Andheri to Pune Cab Booking",
    "description": "Complete Andheri to Pune Cab Booking online with quick confirmation, vehicle selection, affordable fares, and hassle-free travel arrangements."
  },
  {
    "name": "Cab from Andheri to Pune",
    "description": "Hire Cab from Andheri to Pune with Sedan, Ertiga, Innova Crysta, SUV, and luxury cars for comfortable long-distance travel."
  },
  {
    "name": "Andheri to Pune Car Rentals",
    "description": "Choose Andheri to Pune Car Rentals with chauffeur-driven vehicles for business trips, family travel, airport transfers, and private journeys."
  },
  {
    "name": "Andheri to Pune One Way Cab",
    "description": "Book Andheri to Pune One Way Cab for direct travel with affordable fares, professional drivers, and clean AC vehicles."
  },
  {
    "name": "Cheap Andheri to Pune Cab",
    "description": "Choose Cheap Andheri to Pune Cab with budget-friendly pricing, reliable service, and comfortable travel options."
  },
  {
    "name": "Andheri to Pune Taxi Fare",
    "description": "Check Andheri to Pune Taxi Fare with transparent rates, multiple car options, and affordable chauffeur-driven transportation."
  },
  {
    "name": "Book Andheri to Pune Cab Online",
    "description": "Book Andheri to Pune Cab Online with instant confirmation, secure reservation, flexible schedules, and professional driver service."
  },
  {
    "name": "Andheri to Pune Outstation Cab",
    "description": "Travel with Andheri to Pune Outstation Cab featuring safe highway journeys, premium vehicles, and experienced chauffeurs."
  },
  {
    "name": "Andheri to Pune Airport Cab",
    "description": "Reserve Andheri to Pune Airport Cab for airport transfers with timely pickup, luggage assistance, and comfortable AC vehicles."
  },
  {
    "name": "24x7 Andheri to Pune Taxi Service",
    "description": "Get 24x7 Andheri to Pune Taxi Service with round-the-clock availability, quick booking support, and reliable travel solutions."
  },
  {
    "name": "Best Andheri to Pune Cab Service",
    "description": "Choose Best Andheri to Pune Cab Service for affordable fares, premium vehicles, experienced drivers, and dependable intercity travel."
  }
],

"tableData": [
  ["Andheri to Pune Taxi", "Andheri to Pune Round Trip Cab"],
  ["Andheri to Pune Innova Crysta", "Taxi from Mumbai Andheri to Pune"],
  ["Andheri to Pune Ertiga Taxi Fare", "Andheri to Hinjewadi Cab Fare"],
  ["Andheri Airport to Pune Taxi Fare", "Mumbai Airport to Baner Cab Fare"],
  ["Juhu to Pune Cab Service", "Cab Service in Juhu Mumbai"],
  ["Juhu to Pune One Way Cab Fare", "Sakinaka to Pune Cab Service"],
  ["Marol to Pune Cab", "Andheri to Pune Cab"],
  ["Pune to Andheri Cab", "Andheri to Pune Cab Booking"],
  ["Andheri to Pune Car Rentals", "Andheri to Pune One Way Cab"],
  ["Cheap Andheri to Pune Cab", "Book Andheri to Pune Cab Online"],
  ["Andheri to Pune Outstation Cab", "Andheri to Pune Airport Cab"],
  ["24x7 Andheri to Pune Taxi Service", "Best Andheri to Pune Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Andheri to Pune Cab Service",
    WhyChoosedescription: "Trustline Travels offers comfortable Andheri to Pune cab services with professional drivers, well-maintained cars, and dependable travel solutions."
  },
  {
    WhyChooseheading: "Pickup from Andheri Anywhere",
    WhyChoosedescription: "Enjoy convenient pickup from Andheri East, Andheri West, Mumbai Airport area, offices, hotels, and residential locations with direct drop in Pune."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Pune Route",
    WhyChoosedescription: "Our skilled chauffeurs understand the Mumbai-Pune route and ensure a safe, smooth, and timely journey."
  },
  {
    WhyChooseheading: "Comfortable Fleet Options",
    WhyChoosedescription: "Travel according to your requirement with Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers available for booking."
  },
  {
    WhyChooseheading: "Affordable Andheri Pune Cab Fare",
    WhyChoosedescription: "Get transparent pricing with competitive fares and clear details before your booking, ensuring a hassle-free travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Facilities",
    WhyChoosedescription: "Choose from one-way cabs, return trips, or customized travel packages based on your travel plans."
  },
  {
    WhyChooseheading: "Ideal for Airport & Corporate Travel",
    WhyChoosedescription: "Our Andheri to Pune cabs are perfect for Mumbai Airport transfers, business meetings, office travel, and family journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Book your Andheri to Pune cab anytime with quick confirmation and reliable customer support throughout your journey."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Andheri to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Andheri to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Andheri to Pune?",
    answer: "Yes, one-way cab booking is available from Andheri to Pune with flexible pickup and drop options."
  },
  {
    question: "Do you provide pickup from Andheri East and Andheri West?",
    answer: "Yes, we provide pickup facilities from both Andheri East and Andheri West along with nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Andheri to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for different passenger needs."
  },
  {
    question: "Can I book an Andheri to Pune cab for Mumbai Airport travel?",
    answer: "Yes, we provide airport transfer cabs from Andheri and Mumbai Airport areas to Pune."
  },
  {
    question: "Is Andheri to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 for convenient travel at any time."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the booking quotation."
  },
  {
    question: "Can I schedule my Andheri to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide cabs for corporate travel from Andheri to Pune?",
    answer: "Yes, our cab service is suitable for corporate executives, business meetings, employee travel, and professional journeys."
  },
  {
    question: "How can I book Andheri to Pune Cabs with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Wagh",
    feedback: "Trustline Travels provided a smooth Andheri to Pune travel experience with excellent coordination. The driver was punctual, the cab was comfortable, and the entire journey was managed professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Komal Desai",
    feedback: "The service quality was impressive with easy booking, clean vehicle condition, and polite driver support. The ride from Andheri to Pune was comfortable and completely stress-free.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Andheri to Pune Cabs Service",
  "image": "https://www.trustlinetravels.com/assets/images/andheri-to-pune-cabs.webp",
  "description": "Book Andheri to Pune cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services from Andheri Mumbai to Pune with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7745"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/andheri-to-pune-cabs"
  }
};




  return (
    <div>

<Helmet>
  <title>Andheri to Pune Cabs | One Way & Round Trip Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Andheri to Pune cab service with Trustline Travels for reliable and affordable travel. Get one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="andheri to pune taxi, andheri to pune round trip cab, andheri to pune innova crysta, taxi from mumbai andheri to pune, andheri to pune ertiga taxi fare, andheri to hinjewadi cab, Andheri to Pune Cabs, Andheri Mumbai to Pune Taxi, Andheri Pune One Way Cab, Andheri Pune Outstation Taxi, Andheri Pune Airport Cab, Andheri Pune Innova Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/95.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Andheritopunecab;